export default "__VITE_ASSET__94d559da__"